import axios from 'axios';
import Vue from 'vue'

export function jwtInterceptor() {
    axios.interceptors.request.use(request => {
        /*if (localStorage.getItem('token')) {
            request.headers.common.Authorization = localStorage.getItem('token');
        }*/

        const token = localStorage.getItem('expires_in');
        if (localStorage.getItem('jwt') && token != null) {
            request.headers.common.Authorization = 'Bearer ' + localStorage.getItem('jwt');
        }
        return request;
    });

    axios.interceptors.response.use(response => {
        return response;
    }, error => {
        if (error.response.status === 401) {
            Vue.prototype.$cache = null
            Vue.prototype.$userLogged = false
            Vue.prototype.$nameUser = null
            document.location.href = "/plataforma-digital/#/";
            localStorage.clear()
            location.reload();
        }
        return error;
    });
}

jwtInterceptor();


// WEBPACK FOOTER //
// ./src/helpers/jwt.interceptor.js